import Joi from '@hapi/joi'

// Services
import ExtractValidationResult from 'Services/ExtractValidationResult'

const schema = Joi.object({
  dueDate: Joi.string()
    // .label('Due Date')
    // .messages({ 'string.empty': `Please don't leave blank` })
    .required(),
  vendor: Joi.string()
    // .label('Vendor/Payee')
    // .messages({ 'string.empty': `Please don't leave blank` })
    .required(),
  department: Joi.string()
    // .label('Requesting Department')
    // .messages({ 'string.empty': `Please don't leave blank` })
    .required(),
  particulars: Joi.string()
    // .label('Particulars')
    // .messages({ 'string.empty': `Please don't leave blank` })
    .required(),
  project: Joi.string()
    // .label('Project')
    // .messages({ 'string.empty': `Please don't leave blank` })
    .required(),
  releasingCenter: Joi.string()
    // .label('Releasing Center')
    // .messages({ 'string.empty': `Please don't leave blank` })
    .required(),
}).options({ abortEarly: false })

const validate = data => ExtractValidationResult(schema.validate(data))

export default validate
